import { showToast } from '@lokalise/louis';
import { select, takeEvery } from 'redux-saga/effects';

import { getSessionUserId } from '@app/selectors';
import { taskItemComplete, taskLangComplete } from '@app/sockets/socketActions';

export function* showLanguageClosedToast({ payload }: ReturnType<typeof taskLangComplete>) {
    /* Shows closed language modal if the language is set to close automatically */
    const { isAutoClosingLanguages, languageName, completedBy, isAutomaticallyCompleted } = payload;
    const userId: string = yield select(getSessionUserId);

    if (userId === completedBy && isAutoClosingLanguages && isAutomaticallyCompleted) {
        showToast({
            type: 'info',
            title: `${languageName} closed`,
            description: `Your admin set this language to close automatically when the last translation was completed.`,
        });
    }
}

export function* checkLanguageCompleted({ payload }: ReturnType<typeof taskItemComplete>) {
    const { completed, completedBy, languageProgress, task_id: taskId, isAutoClosingLanguages } = payload;

    // task item marked as not completed
    // OR language is closed automatically
    if (!completed || isAutoClosingLanguages) {
        return;
    }

    const userId: string = yield select(getSessionUserId);

    // open the task widget only for who completed the translation
    if (parseInt(userId, 10) !== completedBy) {
        return;
    }

    if (languageProgress >= 100) {
        window.location.assign(`#task:${taskId}`);
    }
}

export default function* initEditorSagas() {
    yield takeEvery(taskLangComplete.match, showLanguageClosedToast);
    yield takeEvery(taskItemComplete.match, checkLanguageCompleted);
}
